import React, { Component } from 'react';
import { ResponsiveModal } from '@getgo/chameleon-react';
import TooltipIcon from '@getgo/chameleon-react/dist/TooltipIcon';
import PropTypes from 'prop-types';
import SearchOrganizers from './Search/Search';
import './OrganizerFilter.css';
import OrganizerFilterButton from '../../../Components/OrganizerFilterButton/OrganizerFilterButton';
import { trackAdminAnalyticsOrganizerFilter } from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { CREATORS_PAGE_COUNT } from '../../../Utils/Constants';

const colors = ['#18e4c9', '#00c3ff', '#1397e9', '#8f53f6', '#d657fd'];

export class OrganizerFilter extends Component {
  static propTypes = {
    creators: PropTypes.array.isRequired,
    filteredCreators: PropTypes.array.isRequired,
    accountKey: PropTypes.string.isRequired,
    getData: PropTypes.func.isRequired,
    isBig: PropTypes.bool.isRequired,
    creatorsFetching: PropTypes.bool.isRequired,
    nextPage: PropTypes.number,
    page: PropTypes.number.isRequired,
    getCreators: PropTypes.func.isRequired,
    fromTime: PropTypes.string.isRequired,
    toTime: PropTypes.string.isRequired,
    resetCreators: PropTypes.func.isRequired
  };

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showOrganizerFilter: false,
      organizers: props.filteredCreators,
      organizeFilterCount: props.filteredCreators.length
    };
  }

  addOrganizer = organizer => {
    this.setState({ organizers: [...this.state.organizers, organizer] });
  };

  removeOrganizer = index => {
    const { organizers } = this.state;
    organizers.splice(index, 1);
    this.setState({ organizers });
  };

  getCreators = (page, searchText, loadCreators = false) => {
    const { getCreators, accountKey, fromTime, toTime } = this.props;
    getCreators(accountKey, fromTime, toTime, page, searchText, CREATORS_PAGE_COUNT, loadCreators);
  };

  toggleOrganizerFilter = () => {
    this.setState({ showOrganizerFilter: !this.state.showOrganizerFilter });
    if (this.state.showOrganizerFilter) {
      this.props.resetCreators();
    }
  };

  updateOrganizerFilter = () => {
    this.setState({ organizeFilterCount: this.state.organizers.length });
    this.toggleOrganizerFilter();
    trackAdminAnalyticsOrganizerFilter(this.props.mixpanelData.action, this.state.organizers.length);
    this.props.getData(this.state.organizers);
  };

  getInitials = name => {
    let initials = '';
    const trimmedName = name ? name.trim() : null;
    if (trimmedName && trimmedName.length > 0) {
      const nameSplit = trimmedName.split(' ');
      const length = nameSplit.length;
      if (length > 0) {
        initials += nameSplit[0][0];

        if (length > 1) {
          initials += nameSplit[length - 1][0];
        }
      }
    }

    return initials;
  };

  getAvatar = (name, index) => (
    <div className="avatarImage" style={{ backgroundColor: colors[index % colors.length] }}>
      {<label id="avatar_initials_label">{this.getInitials(name)}</label>}
    </div>
  );

  getOrganizerDetails = (name, email, index, key) => {
    return (
      <div id={`organizer_row_${index}`} key={key} className="inputFieldContainer">
        {this.getAvatar(name, index)}
        <div className="rowContainer">
          <div className="nameEmailContainer">
            <div className="nameContainer">
              <label id="organizer_name" className="organizerName">
                {name}
              </label>
            </div>
            <label id="organizer_email" className="organizerEmail">
              {email}
            </label>
          </div>
          <button
            className="closeButton"
            onClick={() => {
              this.removeOrganizer(index);
            }}>
            <i className="togo-icon togo-icon-closes" />
          </button>
        </div>
      </div>
    );
  };

  renderOrganizers = () => {
    const { organizers } = this.state;
    const indents = [];
    organizers.forEach((s, index) => {
      indents.push(this.getOrganizerDetails(s.name, s.email, index, s.staffKey));
    });
    return indents;
  };

  renderContent = () => {
    const { creators, creatorsFetching, page, nextPage } = this.props;
    const { t } = this.context;
    const usedKeys = this.state.organizers.map(s => s.staffKey);
    return (
      <div>
        <div className="organizerFilterInstruction">{t('organizerFilter.info')}</div>
        <SearchOrganizers
          placeholder={t('organizerFilter.placeholder')}
          users={[...creators]}
          creatorsFetching={creatorsFetching}
          onUserSelected={this.addOrganizer}
          getCreators={this.getCreators}
          nextPage={nextPage}
          page={page}
          usedKeys={usedKeys}
        />
        <div className="selectedOrganizersList">{this.renderOrganizers()}</div>
      </div>
    );
  };

  renderHeader() {
    const { t } = this.context;
    return (
      <div className="titleContainer">
        <h1 className="title">
          {t('organizerFilter.title')}
          <TooltipIcon
            id="about_notify_update_tooltip_info"
            tooltipPlacement="bottom"
            containerClassName="tooltipContainer"
            description={t('organizerFilter.tooltip')}
          />
        </h1>
      </div>
    );
  }

  renderButtons() {
    const { t } = this.context;
    const buttons = {};
    buttons.primary = {
      text: t('buttons.update'),
      id: 'edit_staff_update_button',
      onClick: this.updateOrganizerFilter,
      disabled: !this.state.organizers.length && !this.state.organizeFilterCount
    };
    buttons.secondary = {
      text: t('buttons.cancel'),
      id: 'edit_staff_cancel_button',
      onClick: this.toggleOrganizerFilter
    };
    return buttons;
  }

  render() {
    const { isBig } = this.props;
    const buttons = this.renderButtons();
    return (
      <div>
        <OrganizerFilterButton
          organizeFilterCount={this.state.organizeFilterCount}
          onClick={this.toggleOrganizerFilter}
          isBig={isBig}
        />
        <ResponsiveModal
          onClose={this.toggleOrganizerFilter}
          isOpen={this.state.showOrganizerFilter}
          titleId="organizer_filter_title"
          customHeader={this.renderHeader()}
          showPrimaryAction={true}
          primaryActionButton={buttons.primary}
          secondaryActionButton={buttons.secondary}>
          <div className="organizerFilterContainer">{this.renderContent()}</div>
        </ResponsiveModal>
      </div>
    );
  }
}

export default OrganizerFilter;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Admin/Filters/OrganizerFilter.js